module.exports = __webpack_public_path__ + "img/PERCENT.86a23bba.svg";